"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var BonusTournamentsList_1 = require("./component/BonusTournamentsList");
var BonusTournamentEditor_1 = require("./component/BonusTournamentEditor");
var BonusTournamentOperationsConfig_1 = require("./component/BonusTournamentOperationsConfig");
var PBonusTournamentsList = /** @class */ (function (_super) {
    __extends(PBonusTournamentsList, _super);
    function PBonusTournamentsList(props) {
        return _super.call(this, props) || this;
    }
    PBonusTournamentsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: []
        }, function () {
            _this.props.listBrands.LoadData();
        });
    };
    PBonusTournamentsList.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PBonusTournamentsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PBonusTournamentsList.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", rootRecord: item });
    };
    PBonusTournamentsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PBonusTournamentsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PBonusTournamentsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PBonusTournamentsList.prototype.onGoBackToListClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PBonusTournamentsList.prototype.onConfigClick = function (item) {
        this.setState({ edit_mode: "CONFIG", rootRecord: item });
    };
    PBonusTournamentsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands, listGameSet: this.props.listGameSet, listDepositAges: this.props.listDepositAges, listPlayerLevels: this.props.listPlayerLevels, listBonusKindsAvail: this.props.listBonusKindsAvail, listAppCurrency: this.props.listAppCurrency }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands, listGameSet: this.props.listGameSet, listDepositAges: this.props.listDepositAges, listPlayerLevels: this.props.listPlayerLevels, listBonusKindsAvail: this.props.listBonusKindsAvail, listAppCurrency: this.props.listAppCurrency }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(BonusTournamentOperationsConfig_1.default, { state: this.props.state, rootRecord: this.state.rootRecord, onGoBackClick: this.onGoBackToListClick.bind(this), dlgSelectBonusTemplate: this.props.dlgSelectBonusTemplate, listAppLanguages: this.props.listAppLanguages, dataPromoTypeAmounts: this.props.dataAmounts, listAppCurrency: this.props.listAppCurrency, dataTickets: this.props.dataTickets, listGameSetGames: this.props.listGameSetGames, dataGames: this.props.dataGames, dataPrizes: this.props.dataPrizes, listBonusTemplates: this.props.listBonusTemplates, listBonusPrizeType: this.props.listBonusPrizeType, dialogViewText: this.props.dialogViewText, dataLocales: this.props.dataLocales, dataBots: this.props.dataBots, listPlayersAvail: this.props.listPlayersAvail, listBotJoinTypes: this.props.listBotJoinTypes, dataSessions: this.props.dataSessions, dlgSelectPlayer: this.props.dlgSelectPlayer, listTournamentGamesAvail: this.props.listTournamentGamesAvail, listTournamentGameLogsList: this.props.listTournamentGameLogsList, listTournamentActionLogsList: this.props.listTournamentActionLogsList, bonusTournamentsMinBetsList: this.props.bonusTournamentsMinBetsList }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PBonusTournamentsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PBonusTournamentsList.getPageDescription = function (state) {
        return {
            icon: "flag-checkered",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_tournaments + "-id",
            itemTitle: "Турниры",
            route: routes_1.routes.page_gift_tournaments,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PBonusTournamentsList;
}(React.Component));
exports.default = PBonusTournamentsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/PBonusTournamentsList.tsx
// module id = 2501
// module chunks = 0